export default [
  {
    id: 1,
    icon: 'icon-live-clock',
    text: 'Calls are answered from 8:30 a.m. to 5:00 p.m. across time zones Eastern (ET), Central (CT), Mountain (MT) and Pacific (PT).'
  },
  {
    id: 2,
    icon: 'icon-live-globe',
    text: 'Currently not available in Atlantic (AT) or Newfoundland (NT) time zones.'
  },
  {
    id: 3,
    icon: 'icon-live-palm',
    text: 'Greetings are personalized up to a maximum of 16 words.'
  },
  {
    id: 4,
    icon: 'icon-live-message',
    text: 'Calls are answered promptly and professionally by a friendly receptionist with your personalized greeting.'
  },
  {
    id: 5,
    icon: 'icon-live-phone',
    text: 'The call is then transferred to a predetermined telephone number of your choice or to voicemail.'
  },
  {
    id: 6,
    icon: 'icon-live-record',
    text: 'You will be provided with a voicemail box and a .wav file will be sent to your email with any voicemail messages.'
  }
]